// extracted by mini-css-extract-plugin
export default {"basicDialog":"pJeCLnVe6XQfOkV82K4J","dialogBody":"eHHfC5YEoREeMY_yC_ol","title":"kyT8qg1Bm8dQBR7EcOpu","message":"zpxokIq4w1yZfbaPdnlr","onlyMessage":"G3FbbuvX9M7uns159uSZ"};